/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'jx3',
    path: '/jx3',
    meta: { tabbar: 'secret/home' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'jx3_assists' },
    children: [
      {
        name: 'jx3_assists',
        path: 'assists',
        meta: { title: '辅助工具' },
        component: () => import('@/views/jx3/assists.vue'),
      },
      /* {
        name: 'jx3_search',
        path: 'search/:type',
        meta: { title: '查询' },
        component: () => import('@/views/jx3/search.vue'),
      }, */
      {
        name: 'jx3_search',
        path: 'search/keju',
        meta: { title: '查询', type: 'keju' },
        component: () => import('@/views/jx3/search.vue'),
      },
    ],
  },
] as RouteConfig[];
